module.exports = __webpack_public_path__ + "static/media/formularze.66fe3e7e.svg";